/* Realtime: ticket do WebSocket e resync. */
import { realtimeTicket, type RealtimeTicket } from "@zapir/shared";
import { request } from "./core";

export const realtimeApi = {
  async realtimeTicket(): Promise<RealtimeTicket> {
    return request("/realtime/ticket", { method: "POST", schema: realtimeTicket });
  },

  async resync(since?: string): Promise<{ ok: boolean }> {
    return request("/realtime/resync", { method: "POST", body: { since } });
  },
};
